
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';

interface PatientsHeaderProps {
  onAddPatient: () => void;
}

const PatientsHeader: React.FC<PatientsHeaderProps> = ({ onAddPatient }) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h2 className="text-2xl font-bold text-gray-900">Patients</h2>
      <Button onClick={onAddPatient} className="bg-blue-600 hover:bg-blue-700">
        <Plus className="h-4 w-4 mr-2" />
        Add Patient
      </Button>
    </div>
  );
};

export default PatientsHeader;
